import React from 'react';
import styled, { useTheme } from 'styled-components';
import ShareBtns from '../../../molecules/ShareBtns';
import { useIntl } from 'react-intl';

const ShareBtnsWrapper = styled.div`
  width: 100%;
  padding: 45px 0;
`;

const ShareBtnsDetailPage = () => {
  const intl = useIntl();
  const theme = useTheme();

  /**
   * @type {React.ComponentProps<typeof ShareBtns>}
   */
  const share = {
    label: intl.formatMessage({
      id: 'jobDetailShareBtnsHeadline',
    }),
    channels: theme.shareBtns,
  };

  return (
    <ShareBtnsWrapper>
      <ShareBtns {...share} flexDirection="column" />
    </ShareBtnsWrapper>
  );
};

export default ShareBtnsDetailPage;
